// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-width[data-v-799135d4] {\n  min-width: 80px;\n}", ""]);
// Exports
module.exports = exports;
